import { CommonModule } from '@angular/common';
import { Component, OnInit, effect, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { LogoComponent } from "../header/widgets/logo/logo.component";
import { FeatherIconComponent } from "../ui/feather-icon/feather-icon.component";
import { SvgIconComponent } from "../ui/svg-icon/svg-icon.component";
import { items, menuItems } from '../../data/menu';
import { Menu } from '../../interface/menu';
import { LayoutService } from '../../services/layout.service';
import { SettingsService } from '../../services/settings.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule, TranslatePipe,
            LogoComponent, FeatherIconComponent, SvgIconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})

export class SidebarComponent implements OnInit {

  public menuItems = menuItems;
  public items = items;
  public leftArrow: boolean = false;
  public rightArrow: boolean = true;
  public pinedItem: Menu[] = [];
  public logoIconUrl: string | null = null;

  private readonly permissions = inject(PermissionService);

  constructor(private router: Router, public layoutService: LayoutService, private readonly settingsService: SettingsService) {
    effect(() => {
      this.permissions.permissions();
      this.menuItems = this.visibleMenu(menuItems);
    });
    this.items.subscribe(itemsFromStore => {
      this.menuItems = this.visibleMenu(itemsFromStore);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlTree = this.router.parseUrl(event.url);
        const cleanPath = '/' + urlTree.root.children['primary']?.segments.map(segment => segment.path).join('/');

        this.clearNavState(this.menuItems);
        this.setNavActiveByPath(this.menuItems, cleanPath);
      }
    });
  }  

  ngOnInit(): void {
    this.settingsService.logoIcon$.subscribe((url) => {
      this.logoIconUrl = url;
    });
  }

  private clearNavState(items: Menu[]) {
    items.forEach((item) => {
      item.active = false;
      if (item.children?.length) {
        this.clearNavState(item.children);
      }
    });
  }

  private setNavActiveByPath(items: Menu[], cleanPath: string): boolean {
    return items.some((item) => {
      const isCurrentPath = item.path === cleanPath;
      const childIsActive = item.children?.length ? this.setNavActiveByPath(item.children, cleanPath) : false;

      item.active = isCurrentPath || childIsActive;
      return item.active;
    });
  }

  toggleMenu(item: Menu) {
    if (!item.children?.length) {
      return;
    }

    if (!item.active) {
      this.menuItems.forEach((menu) => {
        if (this.menuItems.includes(item)) {
          menu.active = false
        }
        if (!menu.children) {
          return false;
        }

        menu.children.forEach((subMenu) => {
          if (menu.children?.includes(item)) {
            subMenu.active = false
          }

          if (subMenu.children) {
            subMenu.children.forEach((details) => {
              if (subMenu.children?.includes(item)) {
                details.active = false;
              }
            })
          }
        })
      })
    }
    item.active =! item.active;
  }

  scrollLeft() {
    this.rightArrow = true;
    if (this.layoutService.margin != 0) {
      this.layoutService.margin = this.layoutService.margin + 500;
    }

    if (this.layoutService.margin == 0) {
      this.leftArrow = false;
    }
  }

  scrollRight() {
    this.leftArrow = true;
    if (this.layoutService.margin != this.layoutService.scrollMargin) {
      this.layoutService.margin = this.layoutService.margin - 500;
    }
    if (this.layoutService.margin == this.layoutService.scrollMargin) {
      this.rightArrow = false;
    }
  }

  closeSidebar() {
    this.layoutService.closeSidebar = true;
  }

  pined(item: Menu) {
    if (!item.pined) {
      this.menuItems.filter((details) => {
        if (details.title) {
          if (this.menuItems.includes(item)) {
            item.pined = true;
            if (!this.pinedItem.includes(item)) {
              this.pinedItem.push(item);
            }
          }
        }
      })
    } else {
      item.pined = false;
      this.pinedItem.splice(this.pinedItem.indexOf(item), 1)
    }

    this.scroll(item)
  }

  private visibleMenu(source: Menu[]): Menu[] {
    const visible = source.flatMap((item) => {
      if (item.children?.length) {
        const children = item.children.filter(
          (child) => !child.id || this.permissions.canReadMenu(child.id),
        );
        return children.length ? [{ ...item, children }] : [];
      }
      if (item.path && item.id && !this.permissions.canReadMenu(item.id)) return [];
      return [item];
    });
    return visible.filter((item, index) => {
      if (!item.main_title) return true;
      const next = visible.slice(index + 1).find((entry) => entry.main_title || entry.path || entry.children);
      return !!next && !next.main_title;
    });
  }

  scroll(item: Menu) {
    if(item && item.id) {
      const scrollDiv = document.getElementById(item.id);
      if(scrollDiv) {
        setTimeout(() => {
          scrollDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100);
      }
    }
  }

}
